import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(() => ({
  deptRadioCtn: {
    flexGrow: 1
  }
}))
